import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';


export default class Payroll {

    static getPayrollDocuments(data,additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'getPayrollDocuments',data, additionalHeaders);
    }

    static getPremiumReports(data,additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'getPremiumReports',data, additionalHeaders);
    }

    static createPayrollChangeRequest(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'createPayrollChangeRequest',[data], authHeader);
    }

    static getPayrollUserContactDetails(authHeader={}){
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'getPayrollUserContactDetails',[], authHeader);
    }

    static getInProgressReportPeriod(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'getInProgressReportPeriod',[data], authHeader);
    }

    static updateAuditReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'updateAuditReport',[data], authHeader);
    }

    static calculatePremiumsForReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'calculatePremiumsForReport',[data], authHeader);
    }
    
    static submitPayrollReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'submitPayrollReport',[data], authHeader);
    }

    static PEcreatePayrollChangeRequest(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'createPayrollChangeRequest',[data], authHeader);
    }

    static PEgetPayrollUserContactDetails(authHeader={}){
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'getPayrollUserContactDetails',[], authHeader);
    }

    static getPremiumReportsSecure_Ext(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'getPremiumReportsSecure_Ext',data, authHeader);
    }
    
    static PEgetInProgressReportPeriod(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'getInProgressReportPeriod',[data], authHeader);
    }

    static PEupdateAuditReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'updateAuditReport',[data], authHeader);
    }

    static PEcalculatePremiumsForReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'calculatePremiumsForReport',[data], authHeader);
    }

    static PEsubmitPayrollReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'submitPayrollReport',[data], authHeader);
    }

    static PEchangeReportStatusToDraft(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'), 'changeReportStatusToDraft',[data], authHeader);
    }
    
    static changeReportStatusToDraft(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('payroll'), 'changeReportStatusToDraft',[data], authHeader);
    }

    static revertAndCreateAuditReport(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypayroll'),'revertAndCreateAuditReport',data, authHeader);
    }
}
